module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-15.6cbd44bc.png";